export default function Error404() {
    return <div>Error 404</div>
}